module.exports = __webpack_public_path__ + "assets/img/Cluey-Learning-2-Landing-Page-+-Website-w720.8d1eef39.webp";